<template>
  <v-card style="border-radius:16px;">
    <v-card-title style="background-color:#EDECEA;">
      <span style="font-size:20px;font-weight:bold;color:#5F5B5A;">{{card.cardName}}</span>
      <v-spacer></v-spacer>
      <img height="32px" :src="require('@/'+ card.extra.iconPath)" alt="card-icon">
    </v-card-title>
    <v-card-actions>
      <!-- <div style="padding-left: 8px;">
        {{ card.cardName }}
      </div> -->
      <v-spacer></v-spacer>
      <v-menu bottom left v-if="false" :disabled="isLoading">
        <v-btn icon slot="activator" :disabled="isLoading">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="configure()">
            <v-list-tile-title>Configurar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="remove()">
            <v-list-tile-title class="red--text text--darken-2">Remover</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-actions>
    <v-card-text>
      <v-layout>
        <v-flex>
          <div v-show="isLoading" style="font-size: 28px; font-weight: 300; width: 56px; text-align: center;">
            <v-progress-circular indeterminate style="color:#00C3D7"></v-progress-circular>
          </div>
          <div v-show="!isLoading" style="font-size:32px;font-weight:500;width:56px;text-align:center;color:#5F5B5A;">
            <span v-show="cardInfo.cardNumber !== 0">{{ cardInfo.cardNumber }}</span>
            <v-icon v-show="cardInfo.cardNumber === 0" color="green">done</v-icon>
          </div>
        </v-flex>
        <v-flex>
          <p style="font-weight:300;height:42px;color:#5F5B5A;">{{ cardInfo.message }}</p>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="px-2">
      <img style="margin-left:10px;" height="25px" :src="require('@/' + (isLoading ? 'assets/dashboard-icons/indicator-gray.png' : cardInfo.lightColor.iconPath))" alt="indicator-icon">
      <v-spacer></v-spacer>
      <v-btn
        small dark rounded depressed
        class="strategio-dialog-button"
        style="background-color:#00C3D7"
        :disabled="isLoading"
        @click="showCardDetails()"
      >Leyenda</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import eventBus from './../../utils/eventBus'
import userStorage from './../../storage/userStorage'

export default {
  name: 'card-template',
  methods: {
    isAdmin () {
      return userStorage.getUserInfo().userType === 'ADMIN'
    },
    showCardDetails () {
      // emit to: /components/dialogs/details-dialog.vue
      eventBus.$emit('open-details-dialog', {
        title: 'Leyenda', // use this.cardDetails.title for a personalized title,
        subtitle: this.card.cardName,
        message: this.card.reference,
        body: this.card.extra.details.body
      })
    }
  },
  computed: {
    cardInfo () {
      return this.card.extra.info(this.isLoading)
    },
    cardDetails () {
      return this.card.extra.details
    }
  },
  props: {
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/card-template.vue